var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7998 21H3.7998C3.53459 21 3.28023 20.8946 3.0927 20.7071C2.90516 20.5196 2.7998 20.2652 2.7998 20V12C2.7998 11.7348 2.90516 11.4804 3.0927 11.2929C3.28023 11.1054 3.53459 11 3.7998 11H6.7998C7.06502 11 7.31938 11.1054 7.50691 11.2929C7.69445 11.4804 7.7998 11.7348 7.7998 12V20C7.7998 20.2652 7.69445 20.5196 7.50691 20.7071C7.31938 20.8946 7.06502 21 6.7998 21ZM13.7998 21H10.7998C10.5346 21 10.2802 20.8946 10.0927 20.7071C9.90516 20.5196 9.7998 20.2652 9.7998 20V3C9.7998 2.73478 9.90516 2.48043 10.0927 2.29289C10.2802 2.10536 10.5346 2 10.7998 2H13.7998C14.065 2 14.3194 2.10536 14.5069 2.29289C14.6944 2.48043 14.7998 2.73478 14.7998 3V20C14.7998 20.2652 14.6944 20.5196 14.5069 20.7071C14.3194 20.8946 14.065 21 13.7998 21ZM20.7998 21H17.7998C17.5346 21 17.2802 20.8946 17.0927 20.7071C16.9052 20.5196 16.7998 20.2652 16.7998 20V9C16.7998 8.73478 16.9052 8.48043 17.0927 8.29289C17.2802 8.10536 17.5346 8 17.7998 8H20.7998C21.065 8 21.3194 8.10536 21.5069 8.29289C21.6944 8.48043 21.7998 8.73478 21.7998 9V20C21.7998 20.2652 21.6944 20.5196 21.5069 20.7071C21.3194 20.8946 21.065 21 20.7998 21Z",
    fill: "#F2F2F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.6168f05051cb100868d0375e61bdfe2c.svg";
export { ForwardRef as ReactComponent };